module.exports = __webpack_public_path__ + "static/docker-1d1c737f57fa1f27a4fc0c8bd556f13e.svg";